<div class="shop-navigation-block-wrapper">
  <div class="row">
    <div class="col-lg-3 d-none d-xl-block">

      <app-dropdown-control [placeholder]="'Newest'" [showClear]="true" 
        [label]="'Sort by'" [options]="sortByOptions" [control]="sortByControl" [name]="'SortBy'"
        [classess]="'mb-unset'"></app-dropdown-control>
    </div>

    <div class="col-xl-9 col-lg-12">
      <div class="d-flex">
        <div class="search-wrapper-block w-100 mr-20-px mr-md-unset">
          <div class="inner-navigation-wrapper">
            <button (click)="filtersVisible = !filtersVisible" pButton pRipple
              class="c-button tertiary static-icon-only d-flex d-xl-none order-1">
              <img src="./../../../../assets/images/icons/filter_list.svg" alt="open-filters">
              <div *ngIf="activeLeftFiltersCount > 0 || activeQuickFiltersCount > 0" class="bubble red">{{activeLeftFiltersCount+activeQuickFiltersCount}}</div>
            </button>

            <button (click)="sortMenu.toggle($event)" pButton pRipple
              class="c-button tertiary static-icon-only d-flex d-xl-none order-md-2 order-4">
              <img src="./../../../../assets/images/icons/sort 1.svg" alt="open-sort-menu">
            </button>

            <div class="order-3 w-100">
              <app-search-input [clearable]="true" [control]="searchControl" [name]="'search'"
                [placeholder]="'Search list'" [loading]="loading"></app-search-input>
            </div>

          </div>
          <p-menu #sortMenu class="order-2 selectable-list-p-menu" [model]="sortMenuItems" [popup]="true"></p-menu>
        </div>
        <div class="pagination-wrapper-block d-md-block d-none">
          @if(initialLoading){
          <div>
            <p-skeleton width="315px" height="40px"></p-skeleton>
          </div>
          } @else {
          <app-pagination [loading]="loading$ | async" [first]="(page$ | async) * perPage" [perPage]="perPage"
            [currentPage]="page$ | async" [totalResults]="totalResults" [collection]="collection"
            [searchTerm]="searchTerm" [hideShopCategoryLabelsInMobile]="true" [showLabel]="false" [inShop]="true" [activeVehicle]="activeVehicle">
          </app-pagination>
          }

        </div>
      </div>

    </div>



  </div>

</div>

<p-sidebar [styleClass]="'no-paddings-sidebar'" [(visible)]="filtersVisible">
  <ng-template pTemplate="header">
    <div class="filters-heading pl-20-px pr-20-px">
      <h3 class="m-unset">Filters</h3>
      <div class="filters-header-actions">
        <span pRipple class="clear-filters mr-16-px" (click)="clearLeftFilters()">Clear filters</span>
        <img (click)="closeFiltersSidebar()" src="./../../../../assets/images/icons/close.svg" alt="close-icon">
      </div>

    </div>
  </ng-template>

  @if(initialLoading){
  <div>
    <p-skeleton width="100%" height="1000px"></p-skeleton>
  </div>
  } @else {

  @if(collection && leftFilters){
  <app-shop-filters [collection]="collection" [leftFilters]="leftFilters" [activeLeftFilters]="activeLeftFilters"
    [totalResults]="totalResults" [initialLoading]="initialLoading" [loading$]="loading$" [sidebar]="true"  [topFilters]="topFilters"
    [activeQuickFilters]="activeQuickFilters">
  </app-shop-filters>
  }

  }


</p-sidebar>
